export default __webpack_public_path__ + "static/media/panelistIcon.30415fd1.svg";